import { render } from "./AccountCreateForm.vue?vue&type=template&id=71dea8ee"
import script from "./AccountCreateForm.vue?vue&type=script&lang=js"
export * from "./AccountCreateForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__